import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ApiService from "../../network/ApiService";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Lazy } from "swiper";
import "swiper/css";
import "swiper/css/lazy";

function Popup({ showModal, onClose }) {
  const { fetchPopup } = ApiService();
  const { organizationId } = useSelector((state) => state.organization);
  const [popUp, setPopUp] = useState([]);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      if (organizationId) {
        try {
          const response = await fetchPopup();
          setPopUp(response.data.messageWithImg);
          setIsReady(true);
        } catch (err) {
          console.error(err.message);
        }
      }
    };
    loadData();
  }, [organizationId]);

  const parseHtmlToView = (str) => ({ __html: str });

  if (!showModal || !isReady || popUp.length === 0) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-2 sm:p-4"
      onClick={onClose}
    >
      <div
        className="
          relative
          bg-white
          rounded-xl
          shadow-2xl
          overflow-hidden
          flex
          flex-col
          items-center

          max-w-6xl
          h-[80vh]       /* Popup container height */
          mt-20
        "
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="
            absolute
            top-3
            right-3
            w-8
            h-8
            flex
            items-center
            justify-center
            bg-white/90
            text-black
            rounded-full
            hover:bg-red-500
            hover:text-white
            transition
            duration-200
            text-xl
            z-50
          "
          aria-label="Close popup"
        >
          ×
        </button>

        <Swiper
          modules={[Autoplay, Lazy]}
          autoplay={{ delay: 2500 }}
          loop
          grabCursor
          lazy={true}
          preloadImages={false}
          className="w-full h-full"
          style={{
            height: "100%",
          
          }}
        >
          {popUp.map((item, index) =>
            item.imageUrlList.map((image, imgIndex) => (
              <SwiperSlide key={`popup_${index}_${imgIndex}`}>
                <div
                  className="
                    flex
                    flex-col
                    items-center
                    justify-center
                    w-full
                    h-full
                    p-2 sm:p-4
                    bg-gradient-to-b from-white to-gray-100
                  "
                >
                  <div
                    className="
                      flex
                      items-center
                      justify-center
                      h-[80vh]  /* You can change image height here */
                      w-full
                      overflow-hidden
                    "
                  >
                    <img
                      src={image}
                      alt={item.header || "Popup image"}
                      loading="lazy"
                      className="
                        object-contain
                        w-full
                        h-full
                        rounded-lg
                        shadow-md
                      "
                    />
                  </div>

                  <div
                    className="
                      mt-3
                      text-center
                      text-sm
                      text-gray-700
                      px-4
                      max-h-[15vh]
                      overflow-y-auto
                    "
                    dangerouslySetInnerHTML={parseHtmlToView(item.message)}
                  ></div>
                </div>
              </SwiperSlide>
            ))
          )}
        </Swiper>
      </div>
    </div>
  );
}

export default Popup;
